<template>
  <v-dialog
    class="text-left"
    v-model="isOpenDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="fixed-bar" dark flat color="primary">
        <v-btn icon dark @click="closeDialog()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title>Add new location</v-toolbar-title>
      </v-toolbar>

      <v-container>
        <v-form ref="locationForm" :model="location">
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a country"
                :items="countries"
                :rules="countryRules"
                item-text="name"
                item-value="id"
                v-model="location.country_id"
                @change="getChildLocations(1, location.country_id)"
              >
              </v-select>
            </v-col>
            <!-- @click="newdialog = !newdialog" -->
            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(1)"
                ><v-icon left>mdi-plus</v-icon>
                Add country
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a state"
                :items="state"
                :rules="stateRules"
                item-text="name"
                item-value="id"
                v-model="location.state_id"
                @change="getChildLocations(2, location.state_id)"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(2)"
                ><v-icon left>mdi-plus</v-icon>
                Add state
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a district"
                :items="district"
                :rules="districtRules"
                item-text="name"
                item-value="id"
                v-model="location.district_id"
                @change="getChildLocations(3, location.district_id)"
              >
              </v-select>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(3)"
                ><v-icon left>mdi-plus</v-icon>
                Add district
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a taluk"
                :items="taluk"
                :rules="talukRules"
                item-text="name"
                item-value="id"
                v-model="location.taluk_id"
                @change="getChildLocations(4, location.taluk_id)"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(4)"
                ><v-icon left>mdi-plus</v-icon>
                Add taluk
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a village"
                :items="village"
                :rules="villageRules"
                item-text="name"
                item-value="id"
                v-model="location.village_id"
                @change="getChildLocations(5, location.village_id)"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(5)"
                ><v-icon left>mdi-plus</v-icon>
                Add village
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-select
                label="Select a area"
                :items="area"
                :rules="areaRules"
                item-text="name"
                item-value="id"
                v-model="location.area_id"
                @change="getChildLocations(6, location.area_id)"
              >
              </v-select>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn
                color="black"
                outlined
                small
                depressed
                class="text-capitalize"
                @click="openAddChildLocation(6)"
                ><v-icon left>mdi-plus</v-icon>
                Add area
              </v-btn>
            </v-col>
          </v-row>
          <br />
           <div class="d-flex flex-row justify-space-between">
          <v-btn style="width:48%" color="primary" @click="createLocation()">Create</v-btn>
         
          <v-btn style="width:48%" @click="closeDialog()">Cancel</v-btn>
          </div>
      

          <v-snackbar
            v-model="snackbarLocation"
            timeout="2500"
            color="primary"
            :snackbarDialog.sync="snackbarLocation"
            >{{ snackbar_location_message }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>

          <!-- POP-UP Dialog box-->
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3">
              <v-card>
                <v-dialog v-model="newdialog" max-width="500px">
                  <v-card>
                    <v-form :model="popup">
                      <v-card-text>
                        <br />
                        <v-text-field
                          :label="dialogRole"
                          v-model="popup.id"
                        ></v-text-field>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="closePopup()">
                          Close
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="handleAddLocation(level, popup.id)"
                        >
                          Add
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog"],
  data() {
    return {
      level: "",
      dialogRole: "",
      popup: {},
      location: {},
      countries: [],
      state: [],
      district: [],
      taluk: [],
      village: [],
      area: [],
      newdialog: false,
      snackbarLocation: false,
      snackbar_location_message: "Location added succesfully",
      countryRules: [(v) => !!v || "Country name is required"],
      stateRules: [(v) => !!v || "Country name is required"],
      districtRules: [(v) => !!v || "Country name is required"],
      villageRules: [(v) => !!v || "Country name is required"],
      talukRules: [(v) => !!v || "Country name is required"],
      areaRules: [(v) => !!v || "Country name is required"],
    };
  },
  created() {},
  computed: {
    isOpenDialog() {
      return this.dialog;
    },
  },
  watch: {
    isOpenDialog(isOpen) {
      if (isOpen) {
        this.$api.getCountries().then((response) => {
          if (response.data.status == "success") {
            this.countries = response.data.countries;
          } else {
            console.log("failed to load");
          }
        });
      }
    },
  },
  methods: {
    getChildLocations(level, row) {
      this.$api
        .getChildLocations({ level: level, parent_id: row })
        .then((response) => {
          if (response.data.status == "success") {
            // var parent_id = row;
            switch (level) {
              case 1:
                this.state = response.data.locations;
                this.location.state_id = "";
                this.location.district_id = "";
                this.location.taluk_id = "";
                this.location.village_id = "";

                break;
              case 2:
                this.district = response.data.locations;
                this.location.district_id = "";
                this.location.taluk_id = "";
                this.location.village_id = "";
                this.level = 2;
                break;
              case 3:
                this.taluk = response.data.locations;
                this.location.taluk_id = "";
                this.location.village_id = "";
                break;
              case 4:
                this.village = response.data.locations;
                this.location.village_id = "";
                break;
              case 5:
                this.area = response.data.locations;
                this.location.area_id = "";
                break;
            }
          } else {
            console.log("failed to load");
          }
        });
    },

    handleAddLocation(level) {
      switch (level) {
        case 1:
          this.countries.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.country_id = this.popup.id;
          break;
        case 2:
          this.state.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.state_id = this.popup.id;
          break;
        case 3:
          this.district.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.district_id = this.popup.id;
          break;
        case 4:
          this.taluk.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.taluk_id = this.popup.id;
          break;
        case 5:
          this.village.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.village_id = this.popup.id;
          break;
        case 6:
          this.area.push({
            id: this.popup.id,
            name: this.popup.id,
          });
          this.location.area_id = this.popup.id;
          break;
      }
      this.popup = [];
      this.newdialog = false;
    },
    openAddChildLocation(level) {
      switch (level) {
        case 1:
          this.dialogRole = "Add new country";
          this.level = 1;
          break;
        case 2:
          this.dialogRole = "Add new state";
          this.level = 2;
          break;
        case 3:
          this.dialogRole = "Add new district";
          this.level = 3;
          break;
        case 4:
          this.dialogRole = "Add new taluk";
          this.level = 4;
          break;
        case 5:
          this.dialogRole = "Add new village";
          this.level = 5;
          break;
        case 6:
          this.dialogRole = "Add new area";
          this.level = 6;
          break;
      }
      this.newdialog = true;
    },
    createLocation() {
      if (this.$refs.locationForm.validate()) {
        this.$api.saveLocation(this.location).then((response) => {
          if (response.data.status == "success") {
            console.log(response.data);
            this.snackbarLocation = true;
            this.closeDialog();
          } else {
            console.log("failed to save new location");
          }
        });
      } else {
        console.log("failed to validate");
      }
    },

    closePopup() {
      this.newdialog = false;
      this.popup = [];
    },
    closeDialog() {
      this.location = [];
      this.countries = [];
      this.dialogRole = [];

      this.$emit("update:dialog", false);
      // this.$emit("update:snackbarDialog", true);
    },
  },
};
</script>
<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 0px;
  z-index: 2;
  border-radius: 0 !important;
}
</style>